<template lang="html">
    <section class="deepfake">
        <div v-if="loading" style="text-align: center">
            <span style="display: inline-block;" class="Vlt-spinner Vlt-spinner--large"></span>
        </div>
        <div v-else class="Vlt-grid Vlt-card Vlt-card--border" id="scrolltop">
            <vlt-button quaternary label="Speak" @click="speak" />

        </div>
    </section>
</template>

<script lang="js">
import {
    $HTTPDEMO,
    requestHandler
} from '@/services/nidsService.js';
import {
    $HTTP
} from '@/services/nidsInternal.js';

import {
    $NODEBASE
} from '@/base';
import axios from 'axios';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { VonageClient } from '@vonage/client-sdk';
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltModal,
    VltCheckbox,
    VltAccordion,
    VltAccordionItem,
} from "@vonagevolta/vue";
export default {
    name: 'deepfake',
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-modal": VltModal,
        "vlt-checkbox": VltCheckbox,
        "vlt-accordion": VltAccordion,
        "vlt-accordion-item": VltAccordionItem,
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        demoItem: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            postscript: "deepfake",
            events: [],
            spin: true,
            spin2: false,
            nodeurl: '',
            gotStats: false,
            users: [],
            allusers: [],
            details: false,
            debug: false,
            curid: 0,
            avg: 0,
            avgcnt: 0,
            avgsum: 0,
            noDB: null,
            timeData: {},
            days: 7,
            invalid: true,
            filter: '',
            keepalive: null,
            loading: true,
            key: 0,
            changes: false,
            fkey: '',
            client: null,
            sessionId: null,
            callId: null,
            speaking: false,
        }
    },
    methods: {
        async register() {
            let res = await this.NODEDEMO.post('/register');
            console.log("Got registration: ", res);
            this.client = new VonageClient();
            if (res.data.user.jwt) {
                this.client.createSession(res.data.user.jwt)
                    .then(sessionId => {
                        console.log("Id of created session: ", sessionId);
                        this.sessionId = sessionId;
                        const listener = this.client.on('conversationEvent', this.eventHandler);
                    })
                    .catch(error => {
                        console.error("Error creating session: ", error);
                    });
            }
        },
        eventHandler(event) {
            console.log("Conversation Event: ", event)
        },
        async speak() {
            if (!this.callId) {
                this.makeCall();
            } else {
                if (this.speaking) {
                    await this.client.mute(this.callId);
                } else {
                    await this.client.unmute(this.callId);
                }
            }
            this.speaking = !this.speaking;
            let res = await this.NODEDEMO.post('/register');

        },
        makeCall() {
            this.client.serverCall({ to: "deepfake:" + this.nexmo.userid, userid: this.nexmo.userid })
                .then(callid => {
                    console.log("Id of created call: ", callid);
                    this.callId = callid;
                })
                .catch(error => {
                    console.error("Error making call: ", error);
                });
        },
    },
    async created() {
        if (!this.demoItem.port) this.demoItem.port = "https://neru-ef3346a6-debug-deepfake.use1.runtime.vonage.cloud";
        if (this.demoItem.port) { //VCR
            console.log("Wow, using the VCR instance!!!", this.demoItem.port)
            this.NODEDEMO = axios.create({
                baseURL: this.demoItem.port + '/',
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } else {
            var ps = "/" + this.postscript;
            if ($NODEBASE.indexOf("ngrok") > 0) {
                ps = "";
            }
            this.nodeurl = $NODEBASE + ps;
            this.NODEDEMO = axios.create({
                baseURL: this.nodeurl,
                headers: {
                    "Content-Type": "application/json",
                },
            });
        }
        this.NODEDEMO.interceptors.request.use(
            request => requestHandler(request)
        );
        this.register();
        this.loading = false;
        if (this.demoItem.port) {
            this.keepalive = setInterval(() => {
                this.NODEDEMO.get('keepalive?id=' + this.nexmo.userid);
                console.log("Keptalive!")
            }, 60 * 1000);
        }
    },
    async beforeDestroy() {
        console.log("beforeDestroy for Deepfake demo")
        if (this.keepalive) {
            clearInterval(this.keepalive);
            this.keepalive = null;
        }
        if (this.client && this.callId) {
            this.client.hangup(this.callId);
            this.callId = null;
        }

    },
}
</script>

<style lang="scss" scoped>
.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
}

.clipped {
    -webkit-clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%);
    clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%);
    padding-right: 15px;

}

.bbutton {
    margin-top: -30px;
    background-color: #00AC83; //blue;
    border: none;
    color: white;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    font-size: large;
    font-weight: bold;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 36px;
}

.bbutton:hover {
    background-color: goldenrod;
    transition: 0.2s;
}

.gbutton {
    margin-top: -30px;
    background-color: white;
    border: none;
    color: gray;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    font-size: large;
    font-weight: bold;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 36px;
}

.gbutton:hover {
    background-color: lightgray;
    transition: 0.2s;
}

.bld {
    font-weight: bold;
    font-size: xxx-large;
}

.ricon {
    margin-left: 10px;
    float: right;
}

.gradN {
    background-image: linear-gradient(255deg, #003385, #0065ff 47%, #ffca00);
}

.grad {
    background-image: linear-gradient(180deg, #fafafa, #00AC83, #006B50);
}

.cent {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 40%;
}

.label1 {
    display: block;
    font-size: 22px;
    font-weight: bold;
    margin-top: 50px;
    color: green;

}

.code {
    display: block;
    white-space: pre-wrap
}
</style>
